"use strict";
/**
 * @name FieldWrapper
 *
 * @description
 *  A FieldWrapper component is a helper component to group common field components together such as inputs, labels,
 *  and messages. If you need a more custom setup, look at creating your own 'FieldGroup' See the teamsnap patterns
 *  library for more information. https://teamsnap-ui-patterns.netlify.com/patterns/components/field-group.html
 *
 * @example
 *  <FieldWrapper
 *    name='example'
 *    label='Test Input'
 *    field='input'
 *    fieldProps={{ placeholder: 'Some placehodler text' }} />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var FieldGroup_1 = require("../FieldGroup");
var FieldLabel_1 = require("../FieldLabel");
var FieldMessage_1 = require("../FieldMessage");
var Input_1 = require("../Input");
var TextArea_1 = require("../TextArea");
var Checkbox_1 = require("../Checkbox");
var Radio_1 = require("../Radio");
var Toggle_1 = require("../Toggle");
var Select_1 = require("../Select");
var types_1 = require("../../types");
var propTypes = {
    name: PropTypes.string.isRequired,
    field: PropTypes.oneOf(['input', 'checkbox', 'radio', 'toggle', 'select', 'textarea']).isRequired,
    fieldProps: PropTypes.any,
    status: types_1.Status.PropType,
    label: PropTypes.node,
    message: PropTypes.string,
    testId: PropTypes.string,
};
var FieldWrapper = function (props) {
    var renderFieldComponent = function () {
        var name = props.name, field = props.field, fieldProps = props.fieldProps;
        var FieldTypes = {
            select: Select_1.Select,
            checkbox: Checkbox_1.Checkbox,
            radio: Radio_1.Radio,
            toggle: Toggle_1.Toggle,
            textarea: TextArea_1.TextArea,
        };
        var FieldTag = FieldTypes[field] || Input_1.Input;
        if ((field === 'checkbox' || field === 'radio') && fieldProps.options) {
            return (fieldProps.options &&
                fieldProps.options.map(function (_a, i) {
                    var label = _a.label, value = _a.value, optionProps = __rest(_a, ["label", "value"]);
                    return (React.createElement(FieldTag, __assign({ key: i }, fieldProps, { group: name, name: "" + name + i, label: label }, optionProps, { inputProps: __assign(__assign(__assign({}, fieldProps.inputProps), optionProps.inputProps), { value: value !== null && value !== void 0 ? value : label }) })));
                }));
        }
        return React.createElement(FieldTag, __assign({ name: name }, fieldProps));
    };
    var status = props.status, name = props.name, label = props.label, message = props.message, testId = props.testId;
    return (React.createElement(FieldGroup_1.FieldGroup, { status: status, testId: testId },
        label && React.createElement(FieldLabel_1.FieldLabel, { name: name },
            label,
            " "),
        renderFieldComponent(),
        message && React.createElement(FieldMessage_1.FieldMessage, { status: status }, message)));
};
FieldWrapper.defaultProps = {
    fieldProps: {},
    status: null,
    label: null,
    message: null,
    testId: null,
};
exports.default = FieldWrapper;
